import { render } from "./dpw-title.vue?vue&type=template&id=eda7af44&scoped=true"
import script from "./dpw-title.vue?vue&type=script&lang=js"
export * from "./dpw-title.vue?vue&type=script&lang=js"

import "./dpw-title.vue?vue&type=style&index=0&id=eda7af44&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eda7af44"]])

export default __exports__